import { useState } from 'react';

// Material UI
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

import useWindowDimensions from '../hooks/useWindowDimensions';



// Icons
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';


const DocumentNavigation = ({ propertyName, setCurrentFolderName, page, setPage, totalItems, totalPages, searchData, setSearchData, breadcrumbs, setBreadcrumbs, isLoadingMore, hideHeader, toggleHeader }) => {
  const { width: displayWidth, mobileVersion } = useWindowDimensions();

  const handleBreadcrumbClick = (index) => {
    const newBreadcrumbs = breadcrumbs.slice(0, index + 1);
    setBreadcrumbs(newBreadcrumbs);
    setCurrentFolderName(newBreadcrumbs[newBreadcrumbs.length - 1].name);
    setPage(1); // Reset to first page when using breadcrumbs
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box sx={{ position: 'sticky', top: hideHeader ? 0 : 212, zIndex: 1001, bgcolor: 'background.default', py: 0.5, px: 3, marginLeft: '10px' }}>
       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' }}>
        <Typography variant='h5'>{propertyName}</Typography>
        <IconButton 
          size="small" 
          onClick={() => toggleHeader(!hideHeader)}
          aria-label={hideHeader ? "Show header" : "Hide header"}
        >
          {hideHeader ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Box>


      <Stack direction={mobileVersion ? "column" : "row"} spacing={2} sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', width: '100%', mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: "flex-start", alignItems: 'center', width: mobileVersion ? '100%' : '50%' }}>
          {totalPages > 1 && <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
            siblingCount={1}
            boundaryCount={0}
          />}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', width: mobileVersion ? '100%' : '50%' }}>
          <Typography>
            {totalItems}
          </Typography>
          {isLoadingMore && <CircularProgress size={20} color="secondary" />}
          <TextField
            placeholder="Search this folder..."
            variant="outlined"
            size="small"
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
            inputProps={{
              'aria-label': 'Search Files',
              'aria-required': true
          }}
            sx={{ width: '300px' }}
            slotProps={{
              input: {
                
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end" >
                  <IconButton  size="small" onClick={() => setSearchData('')}>
                    <ClearIcon aria-label="Clear Search"/>
                  </IconButton>
                  </InputAdornment>
                )
              }
            }}
          />
        </Box>
      </Stack>


      <Breadcrumbs sx={{ mb: 2 }}>
        {breadcrumbs.map((item, index) => (
          index === breadcrumbs.length - 1 ? (
            <Typography key={item.name} color="text.primary" aria-label={`Current Folder: ${item.name}`}>{item.name}</Typography>
          ) : (
            <Link
              key={item.name}
              component="button"
              onClick={() => handleBreadcrumbClick(index)}
              underline="hover"
              color="inherit"
              aria-label={`Navigate to ${item.name}`}
            >
              {item.name}
            </Link>
          )
        ))}
      </Breadcrumbs>
    </Box>
  );
};

export default DocumentNavigation;